<template>
    <dtg-dropdown>
        <template v-if="sharedActionsHidden">
            <dtg-dropdown-item
                :disabled="!canDownloadReport"

                icon="download"

                @click="onReportDownloadClick()"
            >
                Générer et télécharger
            </dtg-dropdown-item>
            <dtg-dropdown-item
                v-bind="backofficeLinkProps"

                icon="dashboard"
            >
                Ouvrir dans MyDTG Manager
            </dtg-dropdown-item>
        </template>
        <dtg-dropdown-item
            v-if="canRepairValidation"

            icon="pageImprovements"

            @click="onRepairValidationClick()"
        >
            Réparer la validation
        </dtg-dropdown-item>
    </dtg-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { DtgDropdown, DtgDropdownItem, events, getName } from 'dtg-components';

import { props } from './props';
import { DtgListItemDropdownEvents } from './types';

import styles from './style.module.scss';

export default defineComponent({
    name: getName(styles),

    components: {
        DtgDropdown,
        DtgDropdownItem,
    },

    props,

    emits: events(['close', 'downloadReport', 'repairValidation'])<DtgListItemDropdownEvents>(),

    setup(props, { emit }) {
        function onRepairValidationClick(): void {
            emit('repairValidation');
        }

        function onReportDownloadClick(): void {
            emit('downloadReport');
        }

        return {
            onRepairValidationClick,
            onReportDownloadClick,
        };
    },
});
</script>
